<template>
  <b-row>
    <b-col cols="12" class="mb-5">
      <PageTitle title="Solicitações profissionais site" />
    </b-col>

    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">
        Encontrado(s) {{ table.records.length }} profissionais no total
      </h3>
    </b-col>
    
    <b-col cols="12" class="mt-4">
      <b-table
        striped
        responsive
        hover
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(created_at)="data">
          {{ dataFormat(data.value) }}
        </template>

        <template #cell(razao_social)="data">
          {{ data.item.nome }} - {{ data.item.usuario_id }}
        </template>

        <template #cell(status)="data">
          <v-select
            v-if="statusActive == data.index"
            class="select"
            v-model="data.item.status"
            :options="optionStatus"
            :loading="loading"
          >
          </v-select>
          <span v-else>
            {{ 
              data.item.status == 1 ? "1 - Em demonstração" : ""  ||
              data.item.status == 2 ? "2 - Demonstração finalizada" : ""  ||
              data.item.status == 3 ? "3 - Aguardando customização" : "" ||
              data.item.status == 4 ? "4 - Pedido de envio" : ""  ||
              data.item.status == 5 ? "5 - Site enviado" : ""  ||
              data.item.status == 6 ? "6 - Site disponível" : "" ||
              data.item.status == 7 ? "7 - Site confirmado pelo profissional" : "" 
            }}
          </span>
        </template>

        <template #cell(actions)="data">
          <b-col style="width: 150px" class="pr-0">

            <b-btn
              @click="showDetails(data.item)"
              variant="warning"
              title="Ver registro"
              class="mb-2 mr-2"
              size="sm"
            >
              <i class="fa fa-search"></i>
            </b-btn>

            <b-btn
              v-if="statusEdit != data.index"
              @click="showSelect(data.index)"
              variant="primary"
              title="Editar registro"
              class="mb-2"
              size="sm"
            >
              <i class="fa fa-pen"></i>
            </b-btn>

            <b-btn
              v-else
              @click="editStatus(data.item)"
              variant="success"
              title="Salvar"
              class="mb-2"
              size="sm"
            >
              <i class="fa fa-check"></i>
            </b-btn>
          </b-col>
        </template>

      </b-table>
    </b-col>

    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
        aria-controls="selectProductsTable"
      ></b-pagination>
    </b-col>

    <b-modal
      title="Dados do profissional"
      size="xl"
      id="dados-profissional-site"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row class="mt-2">
        <b-col cols="6" class="mt-2">
          <label>Nome: </label>
          <b-input :value="profissional.nome" disabled />
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Email: </label>
          <b-input :value="profissional.email" disabled />
        </b-col>

        <b-col cols="4" class="mt-2">
          <label>Telefone: </label>
          <b-input 
            :value="profissional.phone" 
            v-mask="['(##) #####-####', '(##) ####-####']"
            disabled
          />
        </b-col>

        <b-col cols="8" class="mt-2">
          <label>Endereço: </label>
          <b-input 
            :value="profissional.endereco+', Nº'+profissional.numero+', '+profissional.bairro+', '
            +profissional.complemento+', '+profissional.nome_cidade+'-'+profissional.nome_estado+' / '+profissional.cep"
            disabled
          />
        </b-col>

        <b-col cols="8" class="mt-2" v-if="profissional.professional_website_domain">
          <label class="m-0">Url Site:</label>
          <b-input 
            :value="profissional.professional_website_domain"
            disabled
          />
        </b-col>

        <b-col cols="4" class="mt-2" v-if="profissional.professional_website_domain">
          <button 
            class="btn btn-success btn-block mt-4"
            @click="copiarUrl(profissional.professional_website_domain)"
          >
            COPIAR URL SITE
          </button>
        </b-col>

        <b-col cols="6" class="text-center mt-2" v-if="profissional.professional_website_domain">
          <span class="d-none">
            <qrcode-vue
              class="mt-2"
              :value="profissional.professional_website_domain"
              size=500
              level="H"
              id="qrCodeSite"
            />
          </span>
          <qrcode-vue 
            class="mt-2"
            :value="profissional.professional_website_domain" 
            size=250 
            level="H" 
          />

          <button 
            class="btn btn-success btn-block mt-2"
            @click="downloadQrCode('qrCodeSite', 'qrcode_site.png')" 
          >
            BAIXAR QR CODE URL DO SITE 
          </button>
        </b-col>

        <b-col cols="6" class="text-center mt-2" v-if="profissional.foto_principal">
          <img :src="`${getImagesAddress}${profissional.foto_principal}`" alt="Logo" class="imgLogo">

          <button 
            class="btn btn-success btn-block mt-2"
            @click="downloadImage(getImagesAddress+profissional.foto_principal, profissional.foto_principal)"
          >
            BAIXAR LOGO
          </button>
        </b-col>
      </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import makeToast from 'Mixins/makeToast';
import { mapActions, mapGetters } from 'vuex';
import { downloadFileFromBase64 } from '@/utils/index.js';
import SITE_SOLICITATION_STATUS, {
  getText as getSolicitationText,
} from 'Enums/SiteSolicitiation/SiteSolicitationStatus.js';
import PageTitle from 'Components/PageTitle.vue';
import QrcodeVue from 'qrcode.vue';
export default {
  mixins: [makeToast],
  name: 'SolicitationsSite',
  components: {
    PageTitle,
    QrcodeVue
  },
  data() {
    return {
      SITE_SOLICITATION_STATUS,
      loading: false,
      profissional: {},
      filters: {
        name: '',
        status: [], 
        startDate:'',
        endDate: '',
      },
      optionStatus: [
        { label: '1 - Em demonstração', value: 1 },
        { label: '2 - Demonstração finalizada', value: 2 },
        { label: '3 - Aguardando customização', value: 3 },
        { label: '4 - Pedido de envio', value: 4 },
        { label: '5 - Site enviado', value: 5 },
        { label: '6 - Site disponível', value: 6 },
        { label: '7 - Site confirmado pelo profissional', value: 7 }
      ],
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'shopkeeperId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'created_at',
            label: 'Data',
            sortable: true,
          },
          {
            key: 'razao_social',
            label: 'Empresa',
            sortable: true,
          },
          {
            key: 'cnpj',
            label: 'CNPJ',
            sortable: true,
          },
          {
            key: 'email',
            label: 'E-mail',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Ações',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
        records: [],
      },
      statusActive: null,
      statusEdit: null,
      response: 0
    };
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress'])
  },
  created() {
    this.get();
  },
  methods: {
    ...mapActions('files', ['getFileBase64']),
    getSolicitationText,
    async downloadImage(url, fileName) {

      const response = await this.getFileBase64({ url });

      if (!response || !response.data || !response.data.base64) return;

      const { base64 } = response.data || {};

      const extension = (fileName || '').split('.')[1];

      downloadFileFromBase64({
        base64,
        fileName,
        extension,
        mimeType: `image/${extension}`,
        addDataUriOnBase64: true,
      });
    },
    copiarUrl(value) {
      navigator.clipboard.writeText(value);
      this.makeToast('Sucesso!', 'Url copiado com sucesso!', 'success');
    },
    downloadQrCode(elementId, fileName){
      var qrCodeCanvas = document.getElementById(elementId).getElementsByTagName('canvas');
      var dataUrl = qrCodeCanvas[0].toDataURL();

      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };

      xhr.open('GET', dataUrl);
      xhr.send();
    },
    showSelect(index) {
      this.statusEdit = index;
      this.statusActive = index;
    },
    editStatus(index) {
      let objData = {
        id: index.profissional_id,
        status: index.status.value
      };
      
      this.$store.dispatch('startLoader');
      this.$store.dispatch('updateProfissionalStatus', objData)
        .then(() => {
          this.statusEdit = null;
          this.get();
        })
        .catch(() => {
          this.makeToast('Ops!', 'Infelizmente ocorreu um erro, favor tentar novamente!!!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.statusActive = null;
          this.statusEdit = null;
        });
    },
    showDetails(data) {
      console.log(data)
      this.profissional = data;
      this.$bvModal.show('dados-profissional-site');
    },
    get() {
      this.loading = true;

      const request = {
        status: this.filters.status || [],
        startDate: this.filters.startDate || '',
        endDate:this.filters.endDate || '',
      };

      this.$store.dispatch('listarTodasSolicitacoesSite', request)
        .then((response) => {
          this.table.records = response.data || [];
        })
        .catch(() => {
          this.makeToast('Opa!', 'Infelizmente ocorreu um erro, favor tentar novamente!', 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dataFormat(value){
      const dia = value.slice(8,10);
      const mes =  value.slice(5,7);
      const ano = value.slice(0,4);
      const hora = value.slice(11,19);
      return `${dia}/${mes}/${ano} - ${hora}`;
    }
  },
};
</script>

<style scoped>
.imgLogo {
  max-width: 300px;
  height: auto;
}
</style>